module.exports = __webpack_public_path__ + "static/media/HardmodeNeon_5_t.71c30f77.jpg";